import Button from 'components/Button';
import Flex from 'components/Flex';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

interface IProp {
  title: string;
  message: string | JSX.Element;
  actionTitle?: string;
  onClick?: () => void;
}

const ErrorView: FunctionComponent<IProp> = ({ title, message, actionTitle, onClick }) => (
  <ErrorContainer direction="column" alignItems="center" justifyContent="center">
    <ErrorTitle>{title}</ErrorTitle>
    <ErrorMessage>{message}</ErrorMessage>
    {onClick && actionTitle && (
      <Button onClick={onClick} styleType="secondary">
        {actionTitle}
      </Button>
    )}
  </ErrorContainer>
);

export default ErrorView;

const ErrorContainer = styled(Flex)`
  background: #82aa00;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;

  width: 100vw;
  @supports (width: 100dvw) {
    width: 100dvw;
  }

  height: calc(100vh - 82px);
  @supports (height: 100dvh) {
    height: calc(100dvh - 82px);
  }

  ${(props) => props.theme.media.md`
    height: calc(100vh - 118px);
    @supports (height: 100dvh) {
      height: calc(100dvh - 118px);
    }
  `}

  body:not(:has(.header-component)) & {
    min-height: 100vh;
    @supports (height: 100dvh) {
      min-height: 100dvh;
    }
  }
`;

const ErrorTitle = styled.h2`
  font-size: 40px;
  margin-bottom: 40px;
  color: #ffffff;
  white-space: pre-line;
  text-align: center;
  max-width: 900px;
`;

const ErrorMessage = styled.p`
  font-size: 25px;
  margin-bottom: 50px;
  color: #ffffff;
  text-align: center;
  line-height: 35px;
  max-width: 900px;
`;
